import React, {useCallback, useRef} from 'react';
import {StyleSheet, View} from 'react-native';
import BottomSheet from 'src/components/bottom-sheet';
import {isWeb} from '../../../constants';
import {useDispatch, useSelector} from 'react-redux';
import {selectrootsheettype} from '../../../selectors/SheetSelector';
import {showSheet} from '../../../actions/SheetActions';
import {CustomText} from '../../../components';
import {useTranslation} from 'react-i18next';
import SVG from '../../../imports/svg';
import EmptyBox from '../../../components/empty-box/EmptyBox.component';
import Button from '../../../components/button/Button.componet';
import {helperStyles} from '../../../theme/styles';
import PrimaryButton from '../../../components/primary-button/PrimaryButton.component';
import {font} from '../../../theme/Font';
import { useHistory } from '../../../imports/Router';

const RetryCaptureImage = () => {
  const bottomSheetRef = useRef(null);
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const history = useHistory()
  const {sheetId, sheetProps} = useSelector(state =>
    selectrootsheettype(state),
  );

  const closeBottomSheet = () => {
    if (isWeb) {
      bottomSheetRef?.current?.snapTo(() => 0);
    } else {
      bottomSheetRef.current?.close();
      setTimeout(() => {
        dispatch(
          showSheet({
            sheetId: '',
          }),
        );
      }, 500);
    }
  };

  const retryAgain = useCallback(() => {
    closeBottomSheet();
    history.replace({
      pathname: '/dangerous-ride',
      state: {
        IsDangerousRiding: sheetProps?.IsDangerousRiding,
        NumberOfImages: sheetProps?.NumberOfImages,
      },
    });
  }, [history, sheetProps?.IsDangerousRiding, sheetProps?.NumberOfImages]);

  const keepGoing=useCallback(()=>{
    closeBottomSheet()
  },[ closeBottomSheet ])

  return (
    <BottomSheet
      ref={bottomSheetRef}
      snapPoints={isWeb ? ({minHeight}) => [1, minHeight] : [270]}
      onSpringEnd={
        isWeb
          ? () => {
              if (bottomSheetRef?.current?.height < 2) {
                dispatch(
                  showSheet({
                    sheetId: '',
                  }),
                );
              }
            }
          : undefined
      }
      defaultSnap={isWeb ? 270 : undefined}
      open={sheetProps?.visible}
      isScrollView={isWeb ? undefined : false}
      handleIndicatorStyle={
        !isWeb ? {backgroundColor: 'transparent'} : undefined
      }
      onClose={closeBottomSheet}>
      <View style={styles.container}>
        <CustomText size={15} font={'700'} color={'#2D2D2D'}>
          {t('do_you_want_capture_image_again')}
        </CustomText>
        <EmptyBox height={12} />
        <View style={styles.hintContainer}>
          <CustomText mr={8} size={12} font={'400'} color={'#2F3F53'}>
            {t('your_images_will_be_deleted')}
          </CustomText>
          <SVG width={24} height={24} name={'orangeExclamation'} />
        </View>
        <EmptyBox height={48} />
        <PrimaryButton
          containerStyle={styles.retryButton}
          textStyle={styles.retryText}
          onPress={retryAgain}
          title={t('try_again')}
        />
        <PrimaryButton
          containerStyle={styles.keepGoingButton}
          textStyle={styles.keepGoingText}
          onPress={keepGoing}
          title={t('keep_going_with_this_picture')}
        />
      </View>
    </BottomSheet>
  );
};
export default RetryCaptureImage;

const styles = StyleSheet.create({
  keepGoingText: {
    fontSize: 16,
    fontFamily: font[500],
  },
  hintContainer: {
    width: '100%',
    height: 50,
    paddingVertical: 12,
    borderWidth: 1,
    borderColor: '#FFBA4B',
    borderRadius: 18,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingHorizontal: 12,
  },
  retryText: {
    fontSize: 16,
    fontFamily: font[500],
    color : '#2D2D2D' , 
  },
  keepGoingButton: {
    width: '100%',
    marginTop : 10 , 
    height: 40,
    backgroundColor: '#303261',
    paddingTop  : 0 ,
    paddingBottom : 0 , 
    ...helperStyles.centerAlign,
  },
  retryButton: {
    width: '100%',
    height: 40,
    paddingBottom : 0 , 
    borderWidth : 1 , 
    borderColor : '#CFCFCF' , 
    paddingTop  : 0 ,
    backgroundColor: '#fff',
    ...helperStyles.centerAlign,
  },
  container: {
    width: '100%',
    paddingHorizontal: 16,
  },
});
